import { render, staticRenderFns } from "./FattureStock.vue?vue&type=template&id=8e0a73a4"
import script from "./FattureStock.vue?vue&type=script&lang=js"
export * from "./FattureStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports